// The list-and-detail pages shared by every theme: invoices (with their lines), messages and documents.

// invoices: the list on the left opens one invoice on the right
document.addEventListener('DOMContentLoaded', function () {
    const items = document.querySelectorAll('[data-ld-invoice]');

    // the invoice lines come from KAS, so they are only fetched once an invoice is opened
    function loadLines(detail) {
        const wrap = detail ? detail.querySelector('[data-ld-lines-url]') : null;

        if (! wrap || wrap.dataset.ldLoaded) {
            return;
        }

        wrap.dataset.ldLoaded = '1';
        wrap.classList.add('ld-loading');

        fetch(wrap.dataset.ldLinesUrl, {headers: {'X-Requested-With': 'XMLHttpRequest'}, credentials: 'same-origin'})
            .then(function (response) {
                // an expired session redirects to the login page, which must not land inside the invoice
                if (! response.ok || response.redirected) {
                    throw new Error('status ' + response.status);
                }

                return response.text();
            })
            .then(function (html) {
                // an invoice without product lines keeps its summary line
                if (html.trim()) {
                    wrap.innerHTML = html;
                }
            })
            .catch(function () {
                const failed = document.createElement('div');
                const text = document.createElement('span');
                const retry = document.createElement('button');

                failed.className = 'ld-lines-failed';
                text.textContent = wrap.dataset.ldLinesFailed || '';
                retry.type = 'button';
                retry.className = 'ld-lines-retry';
                retry.textContent = wrap.dataset.ldLinesRetry || '';
                failed.append(text, retry);
                wrap.replaceChildren(failed);
            })
            .finally(function () {
                wrap.classList.remove('ld-loading');
            });
    }

    document.addEventListener('click', function (event) {
        const retry = event.target.closest('.ld-lines-retry');
        const detail = retry ? retry.closest('.ld-invoice-detail') : null;

        if (detail) {
            delete detail.querySelector('[data-ld-lines-url]').dataset.ldLoaded;
            loadLines(detail);
        }
    });

    loadLines(document.querySelector('.ld-invoice-detail:not([hidden])'));

    // an invoice opened from a link may sit further down the list: scroll the list to it,
    // measured on screen because offsetTop counts from a positioned ancestor, not from the list
    const opened = document.querySelector('.ld-invoice-item.active');
    const list = opened ? opened.closest('.ld-invoice-list') : null;
    if (list && new URLSearchParams(location.search).get('invoice')) {
        const offset = opened.getBoundingClientRect().top - list.getBoundingClientRect().top;
        list.scrollTop += offset - ((list.clientHeight - opened.offsetHeight) / 2);
    }

    items.forEach(function (item) {
        item.addEventListener('click', function () {
            items.forEach(function (other) {
                const active = (other === item);
                other.classList.toggle('active', active);
                other.setAttribute('aria-selected', active ? 'true' : 'false');
                const detail = document.getElementById(other.dataset.ldInvoice);
                if (detail) {
                    detail.hidden = ! active;
                    if (active) {
                        loadLines(detail);
                    }
                }
            });

            // on a phone the detail sits below the list
            if (window.matchMedia('(max-width: 992px)').matches) {
                const detail = document.getElementById(item.dataset.ldInvoice);
                if (detail) {
                    detail.scrollIntoView({behavior: 'smooth', block: 'start'});
                }
            }
        });
    });
});

// invoice lines arrive after the page loaded, so their product toggles are handled from the document
document.addEventListener('click', function (event) {
    const toggle = event.target.closest('.ld-invoice-lines-toggle');

    if (! toggle) {
        return;
    }

    // "open all" sets every product of this invoice to its own new state
    if (toggle.classList.contains('ld-invoice-lines-all')) {
        const openAll = (toggle.getAttribute('aria-expanded') !== 'true');
        const table = toggle.closest('table');

        toggle.setAttribute('aria-expanded', openAll ? 'true' : 'false');
        toggle.querySelector('.ld-toggle-label').textContent = openAll ? toggle.dataset.close : toggle.dataset.open;
        table.querySelectorAll('.ld-invoice-lines-toggle:not(.ld-invoice-lines-all)').forEach(function (product) {
            product.setAttribute('aria-expanded', openAll ? 'true' : 'false');
            const lines = document.getElementById(product.getAttribute('aria-controls'));
            if (lines) {
                lines.hidden = ! openAll;
            }
        });

        return;
    }

    const lines = document.getElementById(toggle.getAttribute('aria-controls'));
    const open = (toggle.getAttribute('aria-expanded') !== 'true');

    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (lines) {
        lines.hidden = ! open;
    }
});

// messages: the mail decides its own height, so the page scrolls rather than the frame
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ld-message-body').forEach(function (frame) {
        function fit() {
            try {
                const root = frame.contentDocument.documentElement;

                // a mail is laid out for a fixed width; shrink it rather than cut it off
                root.style.zoom = '';
                if (root.scrollWidth > frame.clientWidth) {
                    root.style.zoom = String(frame.clientWidth / root.scrollWidth);
                }

                frame.style.height = (root.getBoundingClientRect().height + 10) + 'px';
            } catch (e) {
                // a frame we cannot read keeps its css height
            }
        }

        frame.addEventListener('load', fit);
        if (frame.contentDocument && (frame.contentDocument.readyState === 'complete')) {
            fit();
        }
    });
});

// documents: the list on the left opens the chosen file in the viewer on the right
document.addEventListener('DOMContentLoaded', function () {
    const items = document.querySelectorAll('.ld-document-item');
    const viewer = document.querySelector('.ld-document-viewer');

    if (! items.length || ! viewer) {
        return;
    }

    const frame = viewer.querySelector('.ld-document-frame');
    const noPreview = viewer.querySelector('.ld-document-no-preview');

    items.forEach(function (item) {
        item.addEventListener('click', function () {
            items.forEach(function (other) {
                other.classList.toggle('active', other === item);
                other.setAttribute('aria-selected', (other === item) ? 'true' : 'false');
            });

            const view = item.dataset.ldDocumentView;
            viewer.querySelector('.ld-document-viewer-title').textContent = item.dataset.ldDocumentName;
            viewer.querySelector('.ld-document-download').href = item.dataset.ldDocumentDownload;
            frame.title = item.dataset.ldDocumentName;
            frame.hidden = ! view;
            noPreview.hidden = !! view;
            frame.src = view || 'about:blank';

            if (window.matchMedia('(max-width: 992px)').matches) {
                viewer.scrollIntoView({behavior: 'smooth', block: 'start'});
            }
        });
    });
});

// a long list scrolls inside its own box; a button at its foot takes it back to the first item
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ld-invoice-list, .ld-message-list, .ld-document-list').forEach(function (list) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ld-list-top';
        button.setAttribute('aria-label', list.dataset.ldToTop || '');
        button.title = list.dataset.ldToTop || '';
        button.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" '
            + 'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m18 15-6-6-6 6"/></svg>';
        list.appendChild(button);

        const update = function () {
            button.classList.toggle('ld-list-top-visible', list.scrollTop > 300);
        };

        list.addEventListener('scroll', update, {passive: true});
        update();

        button.addEventListener('click', function () {
            list.scrollTo({top: 0, behavior: 'smooth'});
        });
    });
});

// the left panel folds away on a desktop, remembered per kind of page in a cookie
document.addEventListener('DOMContentLoaded', function () {
    // Lucide chevrons-left / chevrons-right (ISC licence), drawn inline so no icon font is needed
    const svg = function (paths) {
        return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" '
            + 'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + paths + '</svg>';
    };
    const icon = [
        svg('<path d="m11 17-5-5 5-5"/><path d="m18 17-5-5 5-5"/>'),
        svg('<path d="m6 17 5-5-5-5"/><path d="m13 17 5-5-5-5"/>'),
    ];
    const root = document.documentElement;
    const buttons = [];

    function sync() {
        buttons.forEach(function (entry) {
            const collapsed = root.classList.contains('ld-collapse-' + entry.key);
            const label = collapsed ? entry.grid.dataset.ldExpandLabel : entry.grid.dataset.ldCollapseLabel;

            entry.button.innerHTML = collapsed ? icon[1] : icon[0];
            entry.button.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
            entry.button.setAttribute('aria-label', label || '');
            entry.button.title = label || '';
        });
    }

    document.querySelectorAll('[data-ld-collapse]').forEach(function (grid) {
        const key = grid.dataset.ldCollapse;
        const left = grid.querySelector(':scope > [data-ld-collapse-left]');

        if (! left) {
            return;
        }

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ld-collapse-toggle';
        left.after(button);
        buttons.push({key: key, grid: grid, button: button});

        button.addEventListener('click', function () {
            const collapsed = root.classList.toggle('ld-collapse-' + key);

            document.cookie = 'ld_collapse_' + key + '=' + (collapsed ? '1' : '0') + '; path=/; max-age=31536000; SameSite=Lax';
            sync();

            if (window.Highcharts) {
                window.Highcharts.charts.forEach(function (chart) {
                    if (chart) {
                        chart.reflow();
                    }
                });
            }
        });
    });

    sync();
});

// a mail opened through the address (from the list, or back from an invoice) may sit further down the list
document.addEventListener('DOMContentLoaded', function () {
    const opened = document.querySelector('.ld-message-item.active');
    const list = opened ? opened.closest('.ld-message-list') : null;

    if (list && new URLSearchParams(location.search).get('message')) {
        const offset = opened.getBoundingClientRect().top - list.getBoundingClientRect().top;
        list.scrollTop += offset - ((list.clientHeight - opened.offsetHeight) / 2);
    }
});
